import { BaseService } from '@services/BaseService'

const resource = 'hr/familyhistory'

class FamilyHistoryService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const familyHistoryService = new FamilyHistoryService()
